import styles from "./PromotionTab.module.css.module.css";
import {
    getGeneralImage, isDeviceMobile,
    styleHelper,
} from "../../helpers/commonFunctions";
import useComponentsStore from "../../store/componentsStateStore";
import {useEffect, useState} from "react";
import useHintStore from "../../store/hintStateStore";
import {PromotionTabType} from "../../interfaces/promotionTab/PromotionTab.type";
import useAppStore from "../../store/AppStore";

export default function PromotionTab({
                                                 item,
                                             }: {
    item: PromotionTabType;
}) {
    const icon = item?.icon;
    const action = item?.actionClick;
    const title = item?.title;
    const borderBottomColor = item?.borderBottomColor;
    const isSelected = item?.isSelected;
    const [isLoading, setIsLoading] = useState(false);
    const {
        continueDraft,
        isSelectingTab,
        setIsSelectingTab,

    } = useComponentsStore();
    const { isDeviceMobile } = useAppStore();

    const onClickHandler = async () => {
        if (isLoading || isSelectingTab) return;
        try {
            setIsSelectingTab(true);
            setIsLoading(true);
            await continueDraft(action.payload);
        } catch (err) {
            console.error(err);
        } finally {
            setIsSelectingTab(false);
            setIsLoading(false);
        }
    };
    return (
        <div
            onClick={onClickHandler}
            className={`${!isDeviceMobile ? 'vas-mx-3' : 'vas-w-100'} pointerCursor vas-d-flex vas-flex-column vas-align-items-center vas-pb-3`}
            style={styleHelper({ borderBottom: isSelected ? `2px solid ${borderBottomColor}` : ''})}>
            <div>
                <div className="vas-d-flex vas-align-items-center" style={styleHelper({
                    fontWeight: isSelected ? 'bold' : ''
                })}>
                    <img
                        className="vas vas-d-flex"
                        src={getGeneralImage(icon)}
                        alt=""
                        width={30}
                        height={30}
                    />
                    <div className="vas-text-18 vas-mx-2 vas-d-flex">{title.text}</div>
                </div>
            </div>
        </div>
    );
}
